import "./FinancesRecap.style.css";

// Components
import NavigationBar from "../../../../Components/NavigationBar"
import SideBar from "../../../../Components/SideBar"

// Function
import formatRupiah from "../../../../Function/formatRupiah";

// React Bootstrap
import { Button, InputGroup, Form, Table, Spinner, Placeholder } from "react-bootstrap";

// React Bootstrap Icons
import { Search } from "react-bootstrap-icons";

// React
import { useEffect, useState } from "react";

// React Router Dom
import { useNavigate } from "react-router-dom";

// Axios
import axios from "axios";

const PageFinancesBusinessRecap = () => {
    const navigate = useNavigate();

    const [isPageLoading, setIsPageLoading] = useState(true);
    const [isLoading, setIsLoading] = useState(false);

    const [accessToken] = useState(localStorage.getItem("accessToken"));
    // const [userData] = useState(JSON.parse(localStorage.getItem("userData")));

    const [financeData, setFinanceData] = useState([]);
    const [financeSearch, setFinanceSearch] = useState(new Date().toISOString().slice(0, 10));

    useEffect(() => {
        const fetchData = async () => {
            if (!accessToken) return navigate("/");

            axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
            axios.defaults.headers.common['Accept'] = `application/json`;
            await axios.get(`${process.env.REACT_APP_API_URL}/api/finance/index?search=${new Date().toISOString().slice(0, 10)}`).then((res) => {
                setFinanceData(res.data.data);
            }).catch((err) => {
                if (err.status === 404) setFinanceData(err.response.data);
                else setFinanceData({"message": "Internal Server Error"});
            })

            await setTimeout(() => setIsPageLoading(false), 500);
            return 1;
        }       

        fetchData();
    }, [navigate, accessToken]);

    const handleSearchFinances = async () => {
        if (isLoading) return 1;

        setIsLoading(true);

        axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
        axios.defaults.headers.common['Accept'] = `application/json`;
        await axios.get(`${process.env.REACT_APP_API_URL}/api/finance/index?search=${financeSearch}`).then((res) => {
            setFinanceData(res.data.data);

            setIsLoading(false);
        }).catch((err) => {
            setIsLoading(false);

            if (err.status === 404) setFinanceData(err.response.data);
            else setFinanceData({"message": "Internal Server Error"});
        })
        return 1;
    }

    return (
        <section id="finances-recap" className="finances-recap">
            {/* Navigation Bar */}
            <NavigationBar />

            <div className="content-wrapper">
                {/* Side Bar */}
                <SideBar />

                <div className="contents">
                    {!isPageLoading ? (
                        <>
                            <header>
                                <h4>Finances</h4>
                                <div className="d-flex align-items-center justify-content-center gap-2">
                                    <InputGroup>
                                        <Form.Control type="date" placeholder="Search Finances" value={financeSearch} onChange={(e) => setFinanceSearch(e.target.value)} disabled={isLoading} />
                                        <Button variant="primary" onClick={handleSearchFinances} disabled={isLoading}>{isLoading ? <Spinner size="sm" /> : <Search />}</Button>
                                    </InputGroup>
                                </div>
                            </header>
                            <main>
                                <Table striped bordered hover>
                                    <thead>
                                        <tr>
                                            <th>Date</th>
                                            <th>Income</th>
                                            <th>Expense (Business)</th>
                                            {/* <th>Expense (Personal)</th> */}
                                            {/* <th>Expense (Debt)</th> */}
                                            <th>Balance</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {financeData?.daily && Object.entries(financeData?.daily).map(([date, data]) => (
                                            <tr key={date}>
                                                <td>{date}</td>
                                                <td className="text-primary">{formatRupiah(data.total_income + data.total_finance_income)}</td>
                                                <td className="text-danger">{formatRupiah(data.total_expense_business)}</td>
                                                {/* <td className="text-danger">{formatRupiah(data.total_expense_personal)}</td> */}
                                                {/* <td className="text-danger">{formatRupiah(data.total_expense_debt)}</td> */}
                                                <td className="text-success">{formatRupiah(data.total_income + data.total_finance_income - data.total_expense_business)}</td>
                                            </tr>
                                        ))}
                                        <tr>
                                            <td className="fw-bold">Overall</td>
                                            <td className="fw-bold text-primary">{formatRupiah(financeData?.overall?.total_income + financeData?.overall?.total_finance_income)}</td>
                                            <td className="fw-bold text-danger">{formatRupiah(financeData?.overall?.total_expense_business)}</td>
                                            {/* <td className="fw-bold text-danger">{formatRupiah(financeData?.overall?.total_expense_personal)}</td> */}
                                            {/* <td className="fw-bold text-danger">{formatRupiah(financeData?.overall?.total_expense_debt)}</td> */}
                                            <td className="fw-bold text-success">{formatRupiah(financeData?.overall?.total_income + financeData?.overall?.total_finance_income - financeData?.overall?.total_expense_business)}</td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </main>
                        </>
                    ) : (
                        <>
                            <header>
                                <Placeholder animation="glow">
                                    <Placeholder style={{ borderRadius: "8px",  width: "100px", height: "24px" }} />
                                </Placeholder>
                                <div className="d-flex align-items-center justify-content-center gap-2">
                                    <Placeholder animation="glow">
                                        <Placeholder style={{ borderRadius: "8px",  width: "250px", height: "32px" }} />
                                    </Placeholder>
                                </div>
                            </header>
                            <main>
                                <Table striped bordered hover>
                                    <thead>
                                        <tr>
                                            <th>
                                                <Placeholder animation="glow">
                                                    <Placeholder style={{ borderRadius: "8px",  width: "50px", height: "16px" }} />
                                                </Placeholder>
                                            </th>
                                            <th>
                                                <Placeholder animation="glow">
                                                    <Placeholder style={{ borderRadius: "8px",  width: "75px", height: "16px" }} />
                                                </Placeholder>
                                            </th>
                                            <th>
                                                <Placeholder animation="glow">
                                                    <Placeholder style={{ borderRadius: "8px",  width: "75px", height: "16px" }} />
                                                </Placeholder>
                                            </th>
                                            <th>
                                                <Placeholder animation="glow">
                                                    <Placeholder style={{ borderRadius: "8px",  width: "75px", height: "16px" }} />
                                                </Placeholder>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Array.from({ length: 31 }).map((_, index) => (
                                            <tr key={index}>
                                                <td>
                                                    <Placeholder animation="glow">
                                                    <Placeholder style={{ borderRadius: "8px", width: "100px", height: "16px" }} />
                                                    </Placeholder>
                                                </td>
                                                <td>
                                                    <Placeholder animation="glow">
                                                    <Placeholder style={{ borderRadius: "8px", width: "100px", height: "16px" }} />
                                                    </Placeholder>
                                                </td>
                                                <td>
                                                    <Placeholder animation="glow">
                                                    <Placeholder style={{ borderRadius: "8px", width: "100px", height: "16px" }} />
                                                    </Placeholder>
                                                </td>
                                                <td>
                                                    <Placeholder animation="glow">
                                                    <Placeholder style={{ borderRadius: "8px", width: "100px", height: "16px" }} />
                                                    </Placeholder>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </main>
                        </>
                    )}
                </div>
            </div>
        </section>
    )
}

export default PageFinancesBusinessRecap